import { Component, ViewChild, Input, ElementRef, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { Subscription, ISubscription } from 'rxjs/Subscription';
import { AppService } from '../../../../app.service';
import { DashboardService } from '../../dashboard.service';
import { equipmentVwMdl, SearchItem, Side, ComponentTableInspectionViewModel, ComponentViewViewModel, ComponentType, ComponentActionViewModel } from '../../../../entities';
import { AppUris } from '../../../../entities/app-config/model';
import { CurrentSelection, UserSelectedIds } from '../../../../entities/global/model';
import { TranslateService } from '../../../../translate';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from "@angular/common";
import { trigger, style, animate, transition } from '@angular/animations';
import { NotificationsService } from 'angular2-notifications';
import { CustomEvalService } from '../../../../../app/modules/CustomEval/custom-eval.service';
import { CustomeEvaluationRangeVM } from '../../../../..//app/modules/CustomEval/custom-eval.model';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { DataSource } from '@angular/cdk/table';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort, MatSortModule } from '@angular/material/sort';
import { CryptoService } from '../../../../services/crypto.service';

export enum TableView {
  EquipmentView = 0,
  ComponentView = 1,
  WearRatesView = 2,
}
export enum SearchMode {
  Single = 0,
  Multiple = 1
}
export class OutstantingActionStatus {
  public ComponentId: number = 0;
  public ActionType: number = 0;
  public ActionTitle: string = '';
  public ActionStatus: string = '';
  public CssClass: string = '';
}
export class TrackRollerWorn {
  public ComponentId: number = 0;
  public Worn: number = 0;
  public CssClass: string = '';
}

export enum ComponentColumnHeader {
  Sides = 0,
  Link = 1,
  HoursOnLink = 2,
  Bush = 3,
  BushTurned = 4,
  Shoe = 5,
  FrontIdler = 6,
  RearIdler = 7,
  Sprocket = 8,
  CarrierRollerAvg = 9,
  TrackRollerAvg = 10,
  TrackRollerWorst = 11,
  OutstandingActions = 12,
  TrackRoller = 13,
  CarrierRoller = 14,
  BushTurnedBudget = 15,
  TrackElongation = 16,
  HoursOnBush = 17,
  HoursOnShoe = 18,
  HoursOnFrontIdler = 19,
  HoursOnSproket = 44,
  HoursOnRearIdler = 20,
  HoursOnCarrierR1 = 34,
  HoursOnCarrierR2 = 45,
  HoursOnCarrierR3 = 46,
  HoursOnTractkR1 = 35,
  HoursOnTractkR2 = 36,
  HoursOnTractkR3 = 37,
  HoursOnTractkR4 = 38,
  HoursOnTractkR5 = 39,
  HoursOnTractkR6 = 40,
  HoursOnTractkR7 = 41,
  HoursOnTractkR8 = 42,
  HoursOnTractkR9 = 49,
  HoursOnTractkR10 = 50,
  CarrierRoller_1 = 21,
  CarrierRoller_2 = 22,
  CarrierRoller_3 = 23,
  CarrierRoller_4 = 24,
  CarrierRoller_5 = 25,
  TrackRoller_1 = 26,
  TrackRoller_2 = 27,
  TrackRoller_3 = 28,
  TrackRoller_4 = 29,
  TrackRoller_5 = 30,
  TrackRoller_6 = 31,
  TrackRoller_7 = 32,
  TrackRoller_8 = 33,
  TrackRoller_9 = 47,
  TrackRoller_10 = 48,
  // TrackRoller_11 = 24,
  // TrackRoller_12 = 25,
  // TrackRoller_13 = 26,
  // TrackRoller_14 = 27,
  // TrackRoller_15 = 28,
  // TrackElon = 29,
}

@Component({
  selector: 'component-view',
  templateUrl: './component-view.component.html',
  styleUrls: ['./component-view.component.scss'],
  animations: [
    trigger(
      'fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('500ms', style({ opacity: 0 }))
      ])
    ]
    )]
})
export class ComponentViewComponent {
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('componentPaginator') componentPaginator: MatPaginator;
  @ViewChild('filter') filter: ElementRef;
  @ViewChild('outstandingPopup') ActionsPopup: ElementRef;
  @ViewChild('outstandingPopup') ActionsPopup_: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  @Input() UriConfig: AppUris;
  equipmentDataLoading = true;
  _currentSelection: CurrentSelection = new CurrentSelection();
  _currentSearchItemSelection: SearchItem[] = [];
  _loading = 0;
  selectionSubscription: Subscription;
  selectionSearchItemsSubscription: Subscription;
  translateSubscription: Subscription;
  componentViewListBySearchItemsSubscription: Subscription;
  getExportClickedSubscription: Subscription;
  userLanguage = 'english';
  _tableView: TableView = TableView.ComponentView;
  displayedColumns = ['modelImage', 'EvalL', 'EvalR', 'customer', 'serial', 'unit', 'addiunit', 'make', 'model', 'family', 'smu', 'ltd', 'lastInspectionDate'];
  equipmentList: equipmentVwMdl[] = [];
  eqTableDatabase: EqTableDatabase | null;
  dataSource: EqTableDataSource | null;
  _equipmentRequestToken = 0;
  _componentRequestToken = 0;
  _wearRatesRequestToken = 0;
  componentDisplayedColumns = ['Serial', 'Unit', 'AddiUnit', 'Model', 'Site', 'inspector', 'CurrentSMU', 'LastInspectionDate', 'NextInspectionSMU', 'sides', 'Link', 'HoursOnLink', 'TrackElon', 'Bush', 'BushTurnedBudget', 'BushTurned', 'Shoe', 'FrontIdler', 'RearIdler', 'Sprocket', 'CarrierRollerAVG', 'TrackRollerAVG', 'TrackRollerWorst', 'OutstandingActions'];
  equipmentComponentViewList: ComponentTableInspectionViewModel[] = [];
  componentViewDatabase: ComponentViewTableDatabase | null;
  componentViewDataSource: ComponentViewTableDataSource | null;
  reportingComponentViewDataSource: ComponentViewTableDataSource | null;
  routeSubscription: ISubscription;

  _searchMode: SearchMode = SearchMode.Single;

  viewingEquipmentDetails = false;

  loadSize = 100;
  loadingPage = 1;
  searchCount = 0;
  _currentSort: Sort = { active: 'LastInspectionDate', direction: 'desc' };
  filterVisible = false;
  @Input() routeItemId: number;
  selectedEquipmentId = 0;
  selectedEquipmentRow: equipmentVwMdl = new equipmentVwMdl();
  enableTab: boolean = false
  constructor(private _location: Location, private _route: ActivatedRoute, private _router: Router, private _moduleService: DashboardService,
    private _appService: AppService, private ref: ChangeDetectorRef,
    private _translate: TranslateService,
    private _notification: NotificationsService,
    private elRef: ElementRef, private _evalService: CustomEvalService,
    public dialog: MatDialog,
    private readonly _pref: PreferencesService,
    private _crypto: CryptoService) {
  }

  ngAfterViewInit() {
    this.eqTableDatabase = new EqTableDatabase(this.equipmentList);
    this.dataSource = new EqTableDataSource(this.eqTableDatabase, this.paginator);

    // Initialize componentViewDatabase first
    this.componentViewDatabase = new ComponentViewTableDatabase(this.equipmentComponentViewList);
    this.componentViewDataSource = new ComponentViewTableDataSource(this.componentViewDatabase, this.componentPaginator);

    this.toggleView(TableView.ComponentView);
  }

  ngOnInit() {
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 10));
    if (this._route.snapshot.params.page != null)
      this.loadingPage = this._route.snapshot.params.page;
    this.routeSubscription = this._location.subscribe(l => {
      const page = l.url.split('/');
      this.retrieveEquipmentsComponentViewBySearchItems(Number(page[2]) + 1, this.loadSize);
    });
    this._appService.setPageTitle('Dashboard | Component Overview');
    this._currentSelection = this._appService.getLastSelection();
    this._currentSearchItemSelection = this._appService.getLastSelectionSearchItems();
    this.enableTab = this._appService.getEnableSearch()

    this.selectionSubscription = this._appService.getSelection().subscribe(message => setTimeout(() => { this.selectionChangedDetected(message); }, 10));
    this.selectionSearchItemsSubscription = this._appService.getSelectionSearchItems().subscribe(message => setTimeout(() => { this.selectionSearchItemChangedDetected(message); }, 10));
    this.getExportClickedSubscription = this._moduleService.getExportClicked().subscribe(item => {
      if (item === 1) // 1 means export PDF, at the moment there is only one export option
      {
        this._moduleService.SaveSearchItemsComponentViewForExport(this.loadingPage, this.loadSize, this._currentSearchItemSelection, this._equipmentRequestToken, this._currentSort.active, this._currentSort.direction).subscribe(searchId => { this.printBySearchId(searchId); }, error => console.error(error), () => { });
      }
      else if (item === 2) {
        this.retrieveComponentForReporting(0, 0)
      }
    }, error => console.error(error), () => { });
    // this.eqTableDatabase = new EqTableDatabase(this.equipmentList);
    // this.dataSource = new EqTableDataSource(this.eqTableDatabase, this.paginator);

    // this.componentViewDatabase = new ComponentViewTableDatabase(this.equipmentComponentViewList);
    // this.componentViewDataSource = new ComponentViewTableDataSource(this.componentViewDatabase, this.componentPaginator);

    // this.toggleView(TableView.ComponentView);
  }

  cancelSearch() {
    if (this.componentViewListBySearchItemsSubscription != null)
      this.componentViewListBySearchItemsSubscription.unsubscribe();
    this._loading = 0;
  }


  toggleView(event: any) {
    if (event.value === this._tableView)
      return;
    this._tableView = event.value;

    if (this._tableView === TableView.EquipmentView) {
      this._componentRequestToken = 0;
      this._equipmentRequestToken = 0;
      this._wearRatesRequestToken = 0;
      this.retrieveEquipmentsBySearchItems(1, this.loadSize);
    } else if (this._tableView === TableView.ComponentView) {
      this._componentRequestToken = 0;
      this._equipmentRequestToken = 0;
      this._wearRatesRequestToken = 0;
      this.retrieveEquipmentsComponentViewBySearchItems(this.loadingPage, this.loadSize);
    }
    else {
      this._componentRequestToken = 0;
      this._equipmentRequestToken = 0;
      this._wearRatesRequestToken = 0;
      this.retrieveEquipmentsComponentViewBySearchItems(this.loadingPage, this.loadSize);
    }
  }
  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.selectionSubscription.unsubscribe();
    this.selectionSearchItemsSubscription.unsubscribe();
    // this.componentViewListBySearchItemsSubscription.unsubscribe();
    this.getExportClickedSubscription.unsubscribe();
    if (this.routeSubscription != null)
      this.routeSubscription.unsubscribe();
  }

  handleHideDetails(visible: boolean) {
    this.viewingEquipmentDetails = visible;
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  pageChanged(event: PageEvent) {
    // console.log(event);
    if (this._searchMode === SearchMode.Single)
      this.retrieveEquipmentsByCondition(event.pageIndex + 1, event.pageSize);
    else
      this.retrieveEquipmentsBySearchItems(event.pageIndex + 1, event.pageSize);
  }

  componentPageChanged(event: PageEvent) {
    this.retrieveEquipmentsComponentViewBySearchItems(event.pageIndex + 1, event.pageSize);
    this._router.navigate(['components', (event.pageIndex + 1)]);

    // this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //         this._router.navigate(['components', (event.pageIndex + 1)]);
    //     }else{             
    //       window.open('/components/' + (event.pageIndex + 1), '_blank');

    //     }
    // });
  }
  selectionChangedDetected(current: CurrentSelection) {
    if (this._loading !== 0) {
      return;
    }
    this._currentSelection = current;
    this._searchMode = SearchMode.Single;
    this.retrieveEquipmentsByCondition(1, this.loadSize);
  }

  selectionSearchItemChangedDetected(current: SearchItem[]) {
    this.cancelSearch();
    this._router.navigate(['components', 1]);
    //  this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //         this._router.navigate(['components', 1]);
    //     }else{             
    //       window.open('/components/' + 1, '_blank');

    //     }
    // });

    /*if (this._loading != 0) {
        return;
    }*/

    this._currentSearchItemSelection = current;
    this.enableTab = this._appService.getEnableSearch()
    this._searchMode = SearchMode.Multiple;
    if (this._tableView === TableView.EquipmentView)
      this.retrieveEquipmentsBySearchItems(1, this.loadSize);
    else
      this.retrieveEquipmentsComponentViewBySearchItems(1, this.loadSize);
  }

  retrieveEquipmentsByCondition(pageNo: number, pageSize: number) {
    const userSelectedParam = new UserSelectedIds();
    this.equipmentList = [];
    this.eqTableDatabase.dataChange.next(this.equipmentList);

    userSelectedParam.CustomerId = this._currentSelection.customer.Id;
    userSelectedParam.JobSiteId = this._currentSelection.jobSite.Id;
    userSelectedParam.EquipmentId = this._currentSelection.equipment.Id;
    userSelectedParam.MakeId = this._currentSelection.make.Id;
    userSelectedParam.FamilyId = this._currentSelection.family.Id;
    userSelectedParam.ModelId = this._currentSelection.model.Id;

    this._loading++;
    this._moduleService.getEquipmentCountByCondition(userSelectedParam).subscribe(counts => {
      this._loading++;
      this._moduleService.getEquipmentListByCondition(pageNo, pageSize, userSelectedParam).subscribe(result => {
        this.equipmentList.push(...result);
        this.eqTableDatabase.dataChange.next(this.equipmentList);
        this.paginator.length = counts;
        this.paginator.pageIndex = pageNo - 1;
        this.paginator.pageSize = pageSize;
        this.loadSize = pageSize;
        this.ref.detectChanges();
      }, error => { console.log(error); }, () => { this._loading--; });
    }, error => { console.log(error); }, () => { this._loading--; });
  }


  retrieveEquipmentsBySearchItems(pageNo: number, pageSize: number) {
    this.loadingPage = pageNo;
    this.equipmentList = [];
    this.eqTableDatabase.dataChange.next(this.equipmentList);
    this._loading++;
    this.enableTab = this._appService.getEnableSearch()
    this._equipmentRequestToken++;

    this._moduleService.getEquipmentViewListBySearchItems(pageNo, pageSize, this._currentSearchItemSelection, this._equipmentRequestToken, this._currentSort.active, this._currentSort.direction)
      .subscribe(result => {
        if (result._clientReqId !== this._equipmentRequestToken) {
          console.error('Operarion Cancelled!');
          return;
        }
        this._moduleService.sendExportStatus(1);
        this.equipmentList.push(...result.ResultList);
        this.eqTableDatabase.dataChange.next(this.equipmentList);
        this.paginator.length = result.SearchResult.Total;
        this.paginator.pageIndex = pageNo - 1;
        this.paginator.pageSize = pageSize;
        // console.log('equipment paginator:', this.paginator);
        this.loadSize = pageSize;
        this.ref.detectChanges();
      }, error => { console.log(error); }, () => { this._loading--; });
  }

  retrieveEquipmentsComponentViewBySearchItems(pageNo: number, pageSize: number) {
    this.loadingPage = pageNo;
    this.cancelSearch();
    this.equipmentComponentViewList = [];
    this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
    this._loading++;
    this.enableTab = this._appService.getEnableSearch()
    this._componentRequestToken++;

    this.componentViewListBySearchItemsSubscription = this._moduleService.getComponentViewListBySearchItems(pageNo, pageSize, this._currentSearchItemSelection, this._componentRequestToken, this._currentSort.active, this._currentSort.direction)
      .subscribe(result => {
        if (result._clientReqId !== this._componentRequestToken) {
          console.error('Operation Cancelled!');
          return;
        }
        this._moduleService.sendExportStatus(2);
        // console.log('result.ResultList', result.ResultList);
        this.equipmentComponentViewList.push(...result.ResultList);
        this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
        this.componentPaginator.length = result.SearchResult.Total;
        this.componentPaginator.pageIndex = pageNo - 1;
        this.componentPaginator.pageSize = pageSize;
        this.loadSize = pageSize;
        this.ref.detectChanges();
        // this.equipmentDataLoading = false;
        setTimeout(() => {
          this.equipmentDataLoading = false;
        });
        this._moduleService.getRecommendedActions(result.ResultList.map(m => m.Id)).subscribe(res => {
          ['fleet-condition-widget', 'inspections-performed-widget', 'cost-of-repairs-monthly-widget', 'components-on-eval-widget', 'app-inspections-due-widget'].forEach(m => {
            this._appService.sendWidgetTrigger(m);
          });
          this.equipmentComponentViewList.forEach(m => {
            const filtered = res.find(k => k.EquipmentId === m.Equipment.Id);
            if (filtered) {
              m.LastInspection.RecommendedActions = filtered.RecommendedActions;
              m.Components.forEach(k => {
                k.Actions = filtered.CompletedActions.filter(p => p.ComponentId === k.Id);
              });
            }
            //AES256
            if (m?.LastInspection.Inspector && m?.LastInspection.Inspector.length > 0) {
              m.LastInspection.Inspector = this._crypto.decrypt(m.LastInspection.Inspector);
            }
          });
          //console.log('equipmentComponentViewList:', this.equipmentComponentViewList);
          this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
        }, error => console.error(error), () => { });
      }, error => {
        console.log(error); setTimeout(() => {
          this.equipmentDataLoading = false;
        }); this._loading--;
      }, () => {
        this._loading--; setTimeout(() => {
          this.equipmentDataLoading = false;
        });
      });
  }

  retrieveComponentForReporting(pageNo: number, pageSize: number) {

    this.loadingPage = pageNo;
    pageSize = 0;
    this._moduleService.getComponentViewListBySearchItems(pageNo, pageSize, this._currentSearchItemSelection, this._componentRequestToken, this._currentSort.active, this._currentSort.direction)
      .subscribe(result => {
        if (result._clientReqId !== this._componentRequestToken) {
          console.error('Operation Cancelled!');
          return;
        }

        this.downloadFile(result.ResultList)
        console.log(result.ResultList);

      }, error => { });
  }

  showFilter() {
    this.filterVisible = true;
  }
  rowClicked(row: any) {
    // this.selectedEquipmentId = row.Id;
    // this.selectedEquipmentRow = row;
    // this.viewingEquipmentDetails = true;
    // this._router.navigate(['/equipment', row.Id]);
    window.open('/equipment/' + row.Id, '_blank');

    // this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //       this._router.navigate(['/equipment', row.Id]);
    //     }else{             
    //         window.open('/equipment/' + row.Id, '_blank');

    //     }
    // });

  }

  openEquipmentNewTab(event, equipmentId) {
    event.stopPropagation();
    window.open('/equipment/' + equipmentId, '_blank');

    //   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //       this._router.navigate(['/equipment', equipmentId]);
    //     }else{             
    //         window.open('/equipment/' + equipmentId, '_blank');

    //     }
    // });

  }

  componentRowClicked(row: ComponentTableInspectionViewModel) {
    // console.log(row);
    const equipment = new equipmentVwMdl();
    equipment.customerId = row.Equipment.Customer.Id;
    equipment.customerName = row.Equipment.Customer.Title;
    equipment.EvalL = this._appService.getEvalCode(Math.max(...row.Components.filter(m => m.Side === Side.Left).map(m => m.Worn)));
    equipment.EvalR = this._appService.getEvalCode(Math.max(...row.Components.filter(m => m.Side === Side.Right).map(m => m.Worn)));
    equipment.family = row.Equipment.MakeModelFamily.Family.Title;
    equipment.familyId = row.Equipment.MakeModelFamily.Family.Id;
    equipment.Id = row.Equipment.Id;
    equipment.jobsiteId = row.Equipment.JobSite.Id;
    equipment.jobsiteName = row.Equipment.JobSite.Title;
    equipment.lastInspectionDate = this._appService.formatDate(row.LastInspection.Date);
    equipment.lastInspectionId = row.LastInspection.Id;
    equipment.ltd = row.LastInspection.SMU;
    equipment.make = row.Equipment.MakeModelFamily.Make.Title;
    equipment.makeId = row.Equipment.MakeModelFamily.Make.Id;
    equipment.model = row.Equipment.MakeModelFamily.Model.Title;
    equipment.modelId = row.Equipment.MakeModelFamily.Model.Id;
    equipment.overAllEvalNumber = Math.max(...row.Components.map(m => m.Worn));
    equipment.quoteId = 0;
    equipment.serial = row.Equipment.Serial;
    equipment.unit = row.Equipment.Unit;
    equipment.smu = row.Equipment.SMU;
    equipment.quoteId = row.LastInspection.QuoteId;
    this.selectedEquipmentId = equipment.Id;
    this.selectedEquipmentRow = equipment;
    this.viewingEquipmentDetails = true;
  }

  goToOldHistory(Id: number) {
    window.location.href = this.UriConfig.oldUCUri + 'Track/Undercarriagehistory.aspx?equip_auto=' + Id.toString();
  }

  getComponentValue(componentHeader: ComponentColumnHeader, side: Side, components: ComponentViewViewModel[], row: ComponentTableInspectionViewModel): string {
    switch (componentHeader) {
      case ComponentColumnHeader.Link:
        {
          let value = this.getComponentworn(ComponentType.Link, side, components, 0, false, false).toString();
          if (side == 1) row.LinkL = value;
          else row.LinkR = value;
          return value;
        }

      case ComponentColumnHeader.Bush:
        {
          let value = this.getComponentworn(ComponentType.Bushing, side, components, 0, false, false).toString();
          if (side == 1) row.BushL = value;
          else row.BushR = value;
          return value;
        }

      case ComponentColumnHeader.Shoe:
        {
          let value = this.getComponentworn(ComponentType.Shoe, side, components, 0, false, false).toString();
          if (side == 1) row.ShoeL = value;
          else row.ShoeR = value;
          return value;
        }
      case ComponentColumnHeader.FrontIdler:
        {
          let value = this.getComponentworn(ComponentType.Idler, side, components, 1, false, false).toString();
          if (side == 1) row.FIdlerL = value;
          else row.FIdlerR = value;
          return value;
        }

      case ComponentColumnHeader.RearIdler:
        {
          let value = this.getComponentworn(ComponentType.Idler, side, components, 2, false, false).toString();
          if (side == 1) row.RIdlerL = value;
          else row.RIdlerR = value;
          return value;
        }

      case ComponentColumnHeader.Sprocket:
        {
          let value = this.getComponentworn(ComponentType.Sprocket, side, components, 0, false, false).toString();
          if (side == 1) row.SprocketL = value;
          else row.SprocketL = value;
          return value;
        }

      case ComponentColumnHeader.CarrierRollerAvg:
        {
          let value = this.getComponentworn(ComponentType.CarrierRoller, side, components, 0, true, false).toString();
          if (side == 1) row.CRAvgL = value;
          else row.CRAvgR = value;
          return value;
        }

      case ComponentColumnHeader.TrackRollerAvg:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 0, true, false).toString();
          if (side == 1) row.TRAvgL = value;
          else row.TRAvgR = value;
          return value;
        }

      case ComponentColumnHeader.TrackRollerWorst:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 0, false, false).toString();
          if (side == 1) row.TRWorstL = value;
          else row.TRWorstR = value;
          return value;
        }

      case ComponentColumnHeader.HoursOnLink:
        {
          let value = this.getComponentLife(ComponentType.Link, side, components, 1).toString();
          if (side == 1) row.HoursLinkL = value;
          else row.HoursLinkR = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnSproket:
        {
          let value = this.getComponentLife(ComponentType.Sprocket, side, components, 1).toString();
          if (side == 1) row.HoursSprocketL = value;
          else row.HoursSprocketL = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnBush:
        {
          let value = this.getComponentLife(ComponentType.Bushing, side, components, 1).toString();
          if (side == 1) row.HoursBushL = value;
          else row.HoursBushR = value;
          return value;
        }

      case ComponentColumnHeader.HoursOnShoe:
        {
          let value = this.getComponentLife(ComponentType.Shoe, side, components, 1).toString();
          if (side == 1) row.HoursShoeL = value;
          else row.HoursShoeR = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnFrontIdler:
        {
          let value = this.getComponentLife(ComponentType.Idler, side, components, 1).toString();
          if (side == 1) row.HoursFIdlerL = value;
          else row.HoursFIdlerR = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnRearIdler:
        {
          let value = this.getComponentLife(ComponentType.Idler, side, components, 1).toString();
          if (side == 1) row.HoursRIdlerL = value;
          else row.HoursRIdlerR = value;
          return value;
        }

      case ComponentColumnHeader.HoursOnCarrierR1:
        {
          let value = this.getComponentLife(ComponentType.CarrierRoller, side, components, 1).toString();
          if (side == 1) row.HoursCarrierRoller1L = value;
          else row.HoursCarrierRoller1R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnCarrierR2:
        {
          let value = this.getComponentLife(ComponentType.CarrierRoller, side, components, 2).toString();
          if (side == 1) row.HoursCarrierRoller2L = value;
          else row.HoursCarrierRoller2R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnCarrierR3:
        {
          let value = this.getComponentLife(ComponentType.CarrierRoller, side, components, 3).toString();
          if (side == 1) row.HoursCarrierRoller3L = value;
          else row.HoursCarrierRoller3R = value;
          return value;
        }

      case ComponentColumnHeader.HoursOnTractkR1:
        {
          let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 1).toString();
          if (side == 1) row.HoursTrackRoller1L = value;
          else row.HoursTrackRoller1R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnTractkR2:
        {
          let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 2).toString();
          if (side == 1) row.HoursTrackRoller2L = value;
          else row.HoursTrackRoller2R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnTractkR3:
        {
          let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 3).toString();
          if (side == 1) row.HoursTrackRoller3L = value;
          else row.HoursTrackRoller3R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnTractkR4:
        {
          let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 4).toString();
          if (side == 1) row.HoursTrackRoller4L = value;
          else row.HoursTrackRoller4R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnTractkR5:
        {
          let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 5).toString();
          if (side == 1) row.HoursTrackRoller5L = value;
          else row.HoursTrackRoller5R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnTractkR6:
        {
          let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 6).toString();
          if (side == 1) row.HoursTrackRoller6L = value;
          else row.HoursTrackRoller6R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnTractkR7:
        {
          let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 7).toString();
          if (side == 1) row.HoursTrackRoller7L = value;
          else row.HoursTrackRoller7R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnTractkR8:
        {
          let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 8).toString();
          if (side == 1) row.HoursTrackRoller8L = value;
          else row.HoursTrackRoller8R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnTractkR9:
        {
          let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 9).toString();
          if (side == 1) row.HoursTrackRoller9L = value;
          else row.HoursTrackRoller9R = value;
          return value;
        }
      case ComponentColumnHeader.HoursOnTractkR10:
        {
          let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 10).toString();
          if (side == 1) row.HoursTrackRoller10L = value;
          else row.HoursTrackRoller10R = value;
          return value;
        }
      // case ComponentColumnHeader.HoursOnTractkR2:
      // {
      //     let value = this.getComponentLife(ComponentType.TrackRoller, side, components, 2).toString();
      //     if (side == 1) row.HoursTrackRoller2L = value;
      //     else row.HoursTrackRoller2R = value;
      //     return value;
      // }
      case ComponentColumnHeader.TrackRoller:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 0, false, true).toString();
          if (side == 1) row.TRollerL = value;
          else row.TRollerR = value;
          return value;
        }




      case ComponentColumnHeader.CarrierRoller:
        {
          let value = this.getComponentworn(ComponentType.CarrierRoller, side, components, 0, false, true).toString();
          if (side == 1) row.CRollerL = value;
          else row.CRollerR = value;
          return value;
        }

      case ComponentColumnHeader.BushTurned:
        if (this.checkComponetAction(ComponentType.Bushing, side, components, 1, 12)) // 12 = Turn Pins & bushing
        {
          if (side == 1) row.BushTurnL = "Yes";
          else row.BushTurnR = "Yes";
          return this.Translate('Yes');;

        } else {
          if (side == 1) row.BushTurnL = "No";
          else row.BushTurnR = "No";
          return this.Translate('No');
        }


      case ComponentColumnHeader.BushTurnedBudget:
        {
          let value = this.getbudgetLife(ComponentType.Bushing, side, components, 1).toString();
          if (side == 1) row.BushTurnBudgetL = value;
          else row.BushTurnBudgetR = value;
          return value;
        }
      case ComponentColumnHeader.TrackElongation:
        {
          let value = this.getComponentworn(ComponentType.TrackElongation, side, components, 0, false, false).toString();
          if (side == 1) row.TrackEloL = value;
          else row.TrackEloR = value;
          return value;
        }
      case ComponentColumnHeader.CarrierRoller_1:
        {
          let value = this.getComponentworn(ComponentType.CarrierRoller, side, components, 1, false, false).toString();
          if (side == 1) row.CarrierRoller1L = value;
          else row.CarrierRoller1L = value;
          return value;
        }
      case ComponentColumnHeader.CarrierRoller_2:
        {
          let value = this.getComponentworn(ComponentType.CarrierRoller, side, components, 2, false, false).toString();
          if (side == 1) row.CarrierRoller2L = value;
          else row.CarrierRoller2L = value;
          return value;
        }
      case ComponentColumnHeader.CarrierRoller_3:
        {
          let value = this.getComponentworn(ComponentType.CarrierRoller, side, components, 3, false, false).toString();
          if (side == 1) row.CarrierRoller3L = value;
          else row.CarrierRoller3L = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_1:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 1, false, false).toString();
          if (side == 1) row.TrackRoller1L = value;
          else row.TrackRoller1R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_2:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 2, false, false).toString();
          if (side == 1) row.TrackRoller2L = value;
          else row.TrackRoller2R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_3:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 3, false, false).toString();
          if (side == 1) row.TrackRoller3L = value;
          else row.TrackRoller3R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_4:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 4, false, false).toString();
          if (side == 1) row.TrackRoller4L = value;
          else row.TrackRoller4R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_5:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 5, false, false).toString();
          if (side == 1) row.TrackRoller5L = value;
          else row.TrackRoller5R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_6:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 6, false, false).toString();
          if (side == 1) row.TrackRoller6L = value;
          else row.TrackRoller6R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_7:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 7, false, false).toString();
          if (side == 1) row.TrackRoller7L = value;
          else row.TrackRoller7R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_8:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 8, false, false).toString();
          if (side == 1) row.TrackRoller8L = value;
          else row.TrackRoller8R = value;
          return value;
        }

      case ComponentColumnHeader.TrackRoller_9:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 9, false, false).toString();
          if (side == 1) row.TrackRoller9L = value;
          else row.TrackRoller9R = value;
          return value;
        }

      case ComponentColumnHeader.TrackRoller_10:
        {
          let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 10, false, false).toString();
          if (side == 1) row.TrackRoller10L = value;
          else row.TrackRoller10R = value;
          return value;
        }
      // case ComponentColumnHeader.TrackRoller_1:
      // {
      //     let value = this.getComponentworn(ComponentType.TrackRoller, side, components, 2, false, false).toString();
      //     if (side == 1) row.TrackRoller2L = value;
      //     else row.TrackRoller2R = value;
      //     return value;
      // }


      default:
        return '';
    }
  }
  IsBushTurn: boolean = false;
  getbudgetLifeClass(componentHeader: ComponentColumnHeader, side: Side, components: ComponentViewViewModel[]) {
    const comp = components.find(m => m.Compart.CompartType.Id === ComponentType.Bushing && m.Side === side && m.Position === 1);
    if (!comp) return "-";
    const life = comp.BushTurnLife;
    const bushbudgetless10percent = comp.BushTurnedPercent - 10;
    const bushbudgetless10percentLife = (comp.BushTurnLife / comp.BushTurnedPercent) * bushbudgetless10percent;

    const bushComponentLife = this.getComponentLife(ComponentType.Link, side, components, 1);
    //const IsBushTurn= false;
    //check for bushed turn
    this.IsBushTurn = this.checkComponetAction(ComponentType.Bushing, side, components, 1, 12)



    //check for red colour
    if ((this.IsBushTurn == false) && ((comp.Worn >= comp.BushTurnedPercent) || (bushComponentLife >= comp.BushTurnLife))) {
      // console.log("if__XXX")
      return ' x-bg';
    }
    else if ((this.IsBushTurn == false) && ((comp.Worn >= bushbudgetless10percent && comp.Worn < comp.BushTurnedPercent) || (bushComponentLife >= bushbudgetless10percentLife && bushComponentLife < comp.BushTurnLife))) {
      //console.log("if__CCC")
      return ' c-bg';
    }
    else {
      //console.log("if__AAAA")
      return ' u-bg';
    }

  }
  private getbudgetLife(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number) {

    const comp = components.find(m => m.Compart.CompartType.Id === componentType && m.Side === side && m.Position === position);
    //  console.log("ABCZZZZZZ____",comp)
    if (!comp) return "-";
    const life = comp.BushTurnLife;
    if (life) return life;
    return '-';
  }
  public x: any
  public y: any
  private getComponentworn(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, CalcAvg: boolean, track: boolean): number {

    let comps = components.filter(m => m.Compart.CompartType.Id == componentType && m.Side == side);
    if (position != 0)
      comps = comps.filter(m => m.Position == position);
    if (comps.length == 0) return -1;
    if (CalcAvg) {
      let sum = 0;
      for (let i = 0; i < comps.length; i++) {
        sum += comps[i].Worn;
      }
      const avg = sum / comps.length;

      return +(Math.round(avg * 100) / 100).toFixed(0);
    } else if (!track) {
      return +(Math.round(Math.max(...comps.map(m => m.Worn)) * 100) / 100).toFixed(0);
    }
    this.x = comps.map(m => m.Worn.toFixed(0)).join('% ').concat('% ');
    return this.x;

  }
  private getComponentLife(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number): number {
    const comp = components.find(m => m.Compart.CompartType.Id === componentType && m.Side === side && m.Position === position);
    if (!comp) return -1;
    return comp.Life;
  }

  getComponentClass(componentHeader: ComponentColumnHeader, side: Side, components: ComponentViewViewModel[]): string {
    let worn = 0;
    switch (componentHeader) {
      case ComponentColumnHeader.Link:
        worn = this.getComponentworn(ComponentType.Link, side, components, 0, false, false);
        break;
      case ComponentColumnHeader.HoursOnLink:
        return 'hours';
      case ComponentColumnHeader.TrackElongation:
        worn = this.getComponentworn(ComponentType.TrackElongation, side, components, 0, false, false);
        break;
      case ComponentColumnHeader.Bush:
        worn = this.getComponentworn(ComponentType.Bushing, side, components, 0, false, false);
        break;
      case ComponentColumnHeader.BushTurned:
        return 'actions';
      case ComponentColumnHeader.Shoe:
        worn = this.getComponentworn(ComponentType.Shoe, side, components, 0, false, false);
        break;
      case ComponentColumnHeader.FrontIdler:
        worn = this.getComponentworn(ComponentType.Idler, side, components, 1, false, false);
        break;
      case ComponentColumnHeader.RearIdler:
        worn = this.getComponentworn(ComponentType.Idler, side, components, 2, false, false);
        break;
      case ComponentColumnHeader.Sprocket:
        worn = this.getComponentworn(ComponentType.Sprocket, side, components, 0, false, false);
        break;
      case ComponentColumnHeader.CarrierRollerAvg:
        worn = this.getComponentworn(ComponentType.CarrierRoller, side, components, 0, true, false);
        break;
      case ComponentColumnHeader.TrackRollerAvg:
        worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 0, true, false);
        break;

      case ComponentColumnHeader.TrackRoller:
        worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 0, false, false);

      case ComponentColumnHeader.CarrierRoller:
        worn = this.getComponentworn(ComponentType.CarrierRoller, side, components, 0, false, false);

      case ComponentColumnHeader.TrackRollerWorst:
        worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 0, true, false);

      case ComponentColumnHeader.OutstandingActions:
        return 'actions';
      case ComponentColumnHeader.Sides:
        return 'label';
      default:
        return 'u-bg';
    }
    if (worn <= 30) return ' a-bg';
    if (worn <= 50) return ' b-bg';
    if (worn <= 70) return ' c-bg';
    return ' x-bg';
  }


  private checkComponetAction(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, actionTypeId: number): boolean {

    // console.log("Component Info__ ", components, position, actionTypeId, side, componentType)
    const comp = components.find(m => m.Compart.CompartType.Id === componentType && m.Side === side && m.Position === position);
    if (!comp) return false;
    const action = comp.Actions.find(m => m.ActionType === actionTypeId && m.ComponentId === comp.EqUnitId && m.Side === side);
    if (action) return true;
    return false;
  }
  getNextInspectionCSSClass(dateStr: string): string {
    return this._moduleService.getNextInspectionCSSClass(dateStr);
  }
  getOutstandingActions(side: Side, components: ComponentViewViewModel[], recommendedActions: ComponentActionViewModel[]): string {
    const comps = components.filter(m => m.Side === side);
    let remainingActions = recommendedActions.length;
    for (const cmp of comps) {
      for (const act of cmp.Actions) {
        if (recommendedActions.findIndex(m => m.ComponentId === act.ComponentId && m.ActionType === act.ActionType) >= 0)
          remainingActions--;
      }
    }
    return remainingActions + '/' + recommendedActions.length;
  }
  mouseClientX = '';
  mouseClientY_Top = '';
  mouseClientY_Bottom = '';
  displayActionPopUp = false;
  actionStatusTable: OutstantingActionStatus[] = [];
  mouseOverAction(event: any, row: ComponentTableInspectionViewModel, side: Side) {
    this.actionStatusTable = [];
    this.actionStatusTable = this.getOutstandingTable(row.Components.filter(m => m.Side === side), row.LastInspection.RecommendedActions);
    if (this.actionStatusTable.length === 0) {
      this.displayActionPopUp = false;
      return;
    }
    this.mouseClientX = (event.clientX - 365).toString() + 'px';
    const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    if (event.clientY > h / 2) {
      this.mouseClientY_Bottom = (h - event.clientY).toString() + 'px';
      this.mouseClientY_Top = 'auto';
    }
    else {
      this.mouseClientY_Top = event.clientY + 'px';
      this.mouseClientY_Bottom = 'auto';
    }

    this.displayActionPopUp = true;
  }
  closeActionPopUp() {
    this.actionStatusTable = [];
    this.displayActionPopUp = false;
  }

  mouseleaverAction() {
    this.actionStatusTable = [];
    this.displayActionPopUp = false;
  }
  //Get trackroller frme values
  trackRollerWorn: TrackRollerWorn[]
  displaytrackPopUp: boolean = false;
  evalclass: string
  side_eval
  trackRollerVAl: number[]
  trackPosition: ComponentViewViewModel[]
  mouseOverTrackRollers(event: any, row: ComponentTableInspectionViewModel, side: Side) {
    if (ComponentType.TrackRoller)
      this.trackRollerVAl = this.getComponentTrackworn_(ComponentType.TrackRoller, side, row.Components, 0, false, true);
    this.trackPosition = this.getComponentTrackPosition_(ComponentType.TrackRoller, side, row.Components, 0, false, true);

    if (side == 1)
      this.side_eval = "Left Side"
    else
      this.side_eval = "Right Side"

    if (this.trackRollerVAl.length == 0) {
      this.displaytrackPopUp = false;
      return;
    }
    this.mouseClientX = (event.clientX - 365).toString() + 'px';
    var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    if (event.clientY > h / 2) {
      this.mouseClientY_Bottom = (h - event.clientY).toString() + 'px';
      this.mouseClientY_Top = "auto";
    }
    else {
      this.mouseClientY_Top = event.clientY + 'px';
      this.mouseClientY_Bottom = "auto";
    }
    this.displaytrackPopUp = true;
  }
  closetrackPopUp() {
    this.trackRollerWorn = [];
    this.displaytrackPopUp = false;
  }
  mouseleaveTrackRollers() {
    this.trackRollerWorn = [];
    this.displaytrackPopUp = false;
  }

  private getComponentTrackworn_(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, CalcAvg: boolean, track: boolean): number[] {
    let arraytrack: number[]

    var value = 0;
    let comps = components.filter(m => m.Compart.CompartType.Id == componentType && m.Side == side);
    if (position != 0)
      comps = comps.filter(m => m.Position == position);
    if (comps.length == 0) return [];
    arraytrack = comps.map(m => m.Worn)
    return arraytrack

  }
  private getComponentTrackPosition_(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, CalcAvg: boolean, track: boolean): ComponentViewViewModel[] {

    let arrayPosition: ComponentViewViewModel[]
    var value = 0;

    let comps = components.filter(m => m.Compart.CompartType.Id == componentType && m.Side == side).sort((a, b) => a.Position - b.Position);
    //console.log("before comps___", comps);
    if (position != 0)
      comps = comps.filter(m => m.Position == position).sort((a, b) => a.Position - b.Position);
    if (comps.length == 0) return [];
    arrayPosition = comps;

    if (arrayPosition != null) {
      arrayPosition.map(x => {
        let worn = Math.round(x.Worn).toFixed(0);
        x.Worn = Number(worn);
        //x.evalColor = this.LoadEvalautionForEquipment(x.EquipmentId,Number(worn))
      })
    }
    //console.log("arrayPosition___", arrayPosition);

    return arrayPosition

  }

  EvalautionRange: CustomeEvaluationRangeVM;
  LoadEvalautionForEquipment(equipmentid: number, worn: number): string {
    let val = '';
    this._evalService.GetSelectedLevelRangesForSelectedEquipment(equipmentid).subscribe(res => {
      console.log("res", res);
      this.EvalautionRange = res;

      if (this.EvalautionRange.TrackRollerC != null) {
        if (worn <= this.EvalautionRange.TrackRollerA)
          val = ' a-bg';
        else if (worn <= this.EvalautionRange.TrackRollerB)
          val = ' b-bg';
        else if (worn <= this.EvalautionRange.TrackRollerC)
          val = ' c-bg';
        else
          val = ' x-bg';
      } else {
        if (worn <= this.EvalautionRange.TrackRollerA)
          val = ' a-bg';
        else if (worn <= this.EvalautionRange.TrackRollerB)
          val = ' b-bg';
        else
          val = ' x-bg';
      }
    })
    return val;
  }
  getComponentTrackClass(eval_: string): string {
    //let value=' a-bg';

    // let value =this.LoadEvalautionForEquipment(equipmentId,worn)
    //return value;

    //return value;
    //  this.LoadEvalautionForEquipment(equipmentId,worn)

    if (eval_ == "A") return ' a-bg';
    if (eval_ == "B") return ' b-bg';
    if (eval_ == "C") return ' c-bg';
    if (eval_ == "U") return ' u-bg';
    return ' x-bg';

    // if (worn <= 30) return ' a-bg';
    // if (worn <= 50) return ' b-bg';
    // if (worn <= 70) return ' c-bg';
    // return ' x-bg';
  }
  private getOutstandingTable(components: ComponentViewViewModel[], actions: ComponentActionViewModel[]): OutstantingActionStatus[] {
    const result: OutstantingActionStatus[] = [];
    // console.log(components, actions);
    for (const action of actions) {
      const current: OutstantingActionStatus = new OutstantingActionStatus();
      current.ComponentId = action.ComponentId;
      current.ActionType = action.ActionType;
      current.ActionTitle = this._appService.getActionTitle(action.ActionType);
      const comp = components.find(m => m.Id === action.ComponentId);
      if (comp && comp.Actions.filter(m => m.ActionType === action.ActionType).length > 0) {
        current.ActionStatus = this.Translate('Done');
        current.CssClass = 'Eval-A';
      } else {
        current.ActionStatus = this.Translate('Outstanding');
        current.CssClass = 'Eval-X';
      }
      result.push(current);
    }
    return result;
  }
  sortChanged(sort: Sort) {
    if (this._currentSort.active !== sort.active)
      this.loadingPage = 1;
    this._currentSort = sort;
    this.retrieveEquipmentsComponentViewBySearchItems(this.loadingPage, this.loadSize);
  }

  printBySearchId(searchId: number) {
    if (searchId > 0)
      window.open('components-print/' + searchId, '_blank');
    // this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //       this._router.navigate(['/components-print', searchId]);
    //     }else{             
    //         window.open('components-print/' + searchId, '_blank');

    //     }
    // });

    else {
      this._notification.warn(this.Translate('Operation Failed!'), this.Translate('Something went wrong with current search, please check log!'));
      console.error('Saving current search to database failed!');
    }
  }

  // exportCSVClicked(){
  //     console.log("CSV___DONE")
  //     this.downloadFile(this.reportingComponentViewDataSource)
  // }



  //download csv file
  downloadFile(data: any) {
    console.log("data", data)
    let _data = []
    data.map(p => {
      let _o = {}
      for (var key in p) {
        if (p.hasOwnProperty(key)) {

          if (key == "Serial") {
            _o["Serial #"] = p.Equipment.Serial
          }
          else if (key == "Unit") {
            _o["Unit #"] = p.Equipment.Unit
          } else if (key == "AddiUnit") {
            _o["AddiUnit"] = p.AddiUnit;
          }
          else if (key == "Model") {
            _o["Model"] = p.Model
          }
          else if (key == "Site") {
            _o["Site"] = p.Site;
          }
          else if (key == "SMU") {
            _o["Current SMU"] = p['Equipment'].SMU;
          }
          else if (key == "LastInspDate") {
            _o["Last Inspection Date"] = p[key] == '0001-01-01T00:00:00' ? 'N/A' : p[key];
          }
          else if (key == "NextSMU") {
            _o["Next Inspection SMU"] = p[key];
          }
          else if (key == "NextInspDate") {
            _o["Next Inspection Date"] = p.Equipment.NextInspectionDate;
          }
          else if (key == "LastInspSMU") {
            _o["Last Inspection SMU"] = p[key];
          }
          else if (key == "LinkL") {
            _o["Link L"] = this.getComponentValue(1, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(1, 1, p.Components, p);
          } else if (key == "LinkR") {
            _o["Link R"] = this.getComponentValue(1, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(1, 2, p.Components, p);
          }
          else if (key == "HoursLinkL") {
            _o["HoursLinkL"] = this.getComponentValue(2, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(2, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursLinkR") {
            _o["Hours Link R"] = this.getComponentValue(2, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(2, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateLinkL") {
            _o["Install Date Link L"] = this.getComponentInsatllDate(1, 1, p.Components, p);
          }
          else if (key == "InstallDateLinkR") {
            _o["Install Date Link R"] = this.getComponentInsatllDate(1, 2, p.Components, p);
          }
          else if (key == "BushL") {
            _o["Bush L"] = this.getComponentValue(3, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(3, 1, p.Components, p);
          } else if (key == "BushR") {
            _o["Bush R"] = this.getComponentValue(3, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(3, 2, p.Components, p);
          }
          else if (key == "HoursBushL") {
            _o["Hours Bush L"] = this.getComponentValue(17, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(17, 1, p.Components, p) + 'hrs';
          } else if (key == "HoursBushR") {
            _o["Hours Bush R"] = this.getComponentValue(17, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(17, 2, p.Components, p) + 'hrs';
          }
          else if (key == "InstallDateBushL") {
            _o["Install Date Bush L"] = this.getComponentInsatllDate(3, 1, p.Components, p);
          }
          else if (key == "InstallDateBushR") {
            _o["Install Date Bush R"] = this.getComponentInsatllDate(3, 2, p.Components, p);
          }
          else if (key == "ShoeL") {
            _o["Shoe L"] = this.getComponentValue(5, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(5, 1, p.Components, p);
          } else if (key == "ShoeR") {
            _o["Shoe R"] = this.getComponentValue(5, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(5, 2, p.Components, p);
          }
          else if (key == "HoursShoeL") {
            _o["Hours Shoe L"] = this.getComponentValue(18, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(18, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursShoeR") {
            _o["Hours Shoe R"] = this.getComponentValue(18, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(18, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateShoeL") {
            _o["Install Date Shoe L"] = this.getComponentInsatllDate(5, 1, p.Components, p);
          }
          else if (key == "InstallDateShoeR") {
            _o["Install Date Shoe R"] = this.getComponentInsatllDate(5, 2, p.Components, p);
          }
          else if (key == "BushTurnBudgetL") {
            _o["Bush Turn Budget L"] = this.getComponentValue(15, 1, p.Components, p);
          } else if (key == "BushTurnBudgetR") {
            _o["Bush Turn Budget R"] = this.getComponentValue(15, 2, p.Components, p);
          } else if (key == "BushTurnL") {
            _o["BushTurnL"] = this.getComponentValue(4, 1, p.Components, p);
          } else if (key == "BushTurnR") {
            _o["BushTurnR"] = this.getComponentValue(4, 2, p.Components, p);
          }

          else if (key == "FIdlerL") {
            _o["Front Idler L"] = this.getComponentValue(6, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(6, 1, p.Components, p);
          } else if (key == "FIdlerR") {
            _o["Front Idler R"] = this.getComponentValue(6, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(6, 2, p.Components, p);
          }
          else if (key == "HoursFIdlerL") {
            _o["Hours Front Idler L"] = this.getComponentValue(19, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(19, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursFIdlerR") {
            _o["Hours Rear Idler R"] = this.getComponentValue(19, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(19, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateFIdlerL") {
            _o["Install Date Front Idler L"] = this.getComponentInsatllDate(6, 1, p.Components, p);
          }
          else if (key == "InstallDateFIdlerR") {
            _o["Install Date Rear Idler R"] = this.getComponentInsatllDate(6, 2, p.Components, p);
          }

          else if (key == "RIdlerL") {
            _o["Rear Idler L"] = this.getComponentValue(7, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(7, 1, p.Components, p);
          } else if (key == "RIdlerR") {
            _o["Rear Idler R"] = this.getComponentValue(7, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(7, 2, p.Components, p);
          }
          else if (key == "HoursRIdlerL") {
            _o["HoursRIdlerL"] = this.getComponentValue(20, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(20, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursRIdlerR") {
            _o["HoursRIdlerR"] = this.getComponentValue(20, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(20, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateRIdlerL") {
            _o["InstallDateRIdlerL"] = this.getComponentInsatllDate(7, 1, p.Components, p);
          }
          else if (key == "InstallDateRIdlerR") {
            _o["InstallDateRIdlerR"] = this.getComponentInsatllDate(7, 2, p.Components, p);
          }

          else if (key == "SprocketL") {
            _o["SprocketL"] = this.getComponentValue(8, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(8, 1, p.Components, p);
          } else if (key == "SprocketR") {
            _o["SprocketR"] = this.getComponentValue(8, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(8, 2, p.Components, p);
          }
          else if (key == "HoursSprocketL") {
            _o["HoursSprocketL"] = this.getComponentValue(44, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(44, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursSprocketR") {
            _o["HoursSprocketR"] = this.getComponentValue(44, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(44, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateSprocketL") {
            _o["InstallDateSprocketL"] = this.getComponentInsatllDate(8, 1, p.Components, p);
          }
          else if (key == "InstallDateSprocketR") {
            _o["InstallDateSprocketR"] = this.getComponentInsatllDate(8, 2, p.Components, p);
          }
          else if (key == "CRAvgL") {
            _o["Carrier Roller AVG L"] = this.getComponentValue(9, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(9, 1, p.Components, p);
          } else if (key == "CRAvgR") {
            _o["Carrier Roller AVG R"] = this.getComponentValue(9, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(9, 2, p.Components, p);
          }
          else if (key == "CarrierRoller1L") {
            _o["Carrier Roller1 L"] = this.getComponentValue(21, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(21, 1, p.Components, p);
          } else if (key == "CarrierRoller1R") {
            _o["Carrier Roller1 R"] = this.getComponentValue(21, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(21, 2, p.Components, p);
          }
          else if (key == "HoursCarrierRoller1L") {
            _o["HoursCarrierRoller1L"] = this.getComponentValue(34, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(34, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursCarrierRoller1R") {
            _o["HoursCarrierRoller1R"] = this.getComponentValue(34, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(34, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateCarrierRoller1L") {
            _o["InstallDateCarrierRoller1L"] = this.getComponentInsatllDate(21, 1, p.Components, p);
          }
          else if (key == "InstallDateCarrierRoller1R") {
            _o["InstallDateCarrierRoller1R"] = this.getComponentInsatllDate(21, 2, p.Components, p);
          }

          else if (key == "CarrierRoller2L") {
            _o["Carrier Roller2 L"] = this.getComponentValue(22, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(22, 1, p.Components, p);
          } else if (key == "CarrierRoller2R") {
            _o["Carrier Roller2 R"] = this.getComponentValue(22, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(22, 2, p.Components, p);
          }
          else if (key == "HoursCarrierRoller2L") {
            _o["HoursCarrierRoller2L"] = this.getComponentValue(45, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(45, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursCarrierRoller2R") {
            _o["HoursCarrierRoller2R"] = this.getComponentValue(45, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(45, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateCarrierRoller2L") {
            _o["InstallDateCarrierRoller2L"] = this.getComponentInsatllDate(22, 1, p.Components, p);
          }
          else if (key == "InstallDateCarrierRoller2R") {
            _o["InstallDateCarrierRoller2R"] = this.getComponentInsatllDate(22, 2, p.Components, p);
          }

          else if (key == "CarrierRoller3L") {
            _o["Carrier Roller3 L"] = this.getComponentValue(23, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(23, 1, p.Components, p);
          } else if (key == "CarrierRoller3R") {
            _o["Carrier Roller3 R"] = this.getComponentValue(23, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(23, 2, p.Components, p);
          }
          else if (key == "HoursCarrierRoller3L") {
            _o["HoursCarrierRoller3L"] = this.getComponentValue(46, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(46, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursCarrierRoller3R") {
            _o["HoursCarrierRoller3R"] = this.getComponentValue(46, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(46, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateCarrierRoller3L") {
            _o["InstallDateCarrierRoller3L"] = this.getComponentInsatllDate(23, 1, p.Components, p);
          }
          else if (key == "InstallDateCarrierRoller3R") {
            _o["InstallDateCarrierRoller3R"] = this.getComponentInsatllDate(23, 2, p.Components, p);
          }

          else if (key == "TRAvgL") {
            _o["Track Roller Avg L"] = this.getComponentValue(10, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(10, 1, p.Components, p);
          } else if (key == "TRAvgR") {
            _o["Track Roller Avg R"] = this.getComponentValue(10, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(10, 2, p.Components, p);
          } else if (key == "TRWorstL") {
            _o["Track Roller Worst L"] = this.getComponentValue(11, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(11, 1, p.Components, p);
          } else if (key == "TRWorstR") {
            _o["Track Roller Worst R"] = this.getComponentValue(11, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(11, 2, p.Components, p);
          }

          else if (key == "TrackRoller1L") {
            _o["Track Roller1 L"] = this.getComponentValue(26, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(26, 1, p.Components, p);
          } else if (key == "TrackRoller1R") {
            _o["Track Roller1 R"] = this.getComponentValue(26, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(26, 2, p.Components, p);
          }
          else if (key == "HoursTrackRoller1L") {
            _o["Hours Track Roller1 L"] = this.getComponentValue(35, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(35, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursTrackRoller1R") {
            _o["HoursTrackRoller1R"] = this.getComponentValue(35, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(35, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateTrackRoller1L") {
            _o["InstallDateTrackRoller1L"] = this.getComponentInsatllDate(26, 1, p.Components, p);
          }
          else if (key == "InstallDateTrackRoller1R") {
            _o["InstallDateTrackRoller1R"] = this.getComponentInsatllDate(26, 2, p.Components, p);
          }
          else if (key == "TrackRoller2L") {
            _o["TrackRoller2L"] = this.getComponentValue(27, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(27, 1, p.Components, p);
          } else if (key == "TrackRoller2R") {
            _o["TrackRoller2R"] = this.getComponentValue(27, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(27, 2, p.Components, p);;
          }
          else if (key == "HoursTrackRoller2L") {
            _o["HoursTrackRoller2L"] = this.getComponentValue(36, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(36, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursTrackRoller2R") {
            _o["HoursTrackRoller2R"] = this.getComponentValue(36, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(36, 2, p.Components, p) + ' hrs';;
          }
          else if (key == "InstallDateTrackRoller2L") {
            _o["InstallDateTrackRoller2L"] = this.getComponentInsatllDate(27, 1, p.Components, p);
          }
          else if (key == "InstallDateTrackRoller2R") {
            _o["InstallDateTrackRoller2R"] = this.getComponentInsatllDate(27, 2, p.Components, p);
          }

          else if (key == "TrackRoller3L") {
            _o["TrackRoller3L"] = this.getComponentValue(28, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(28, 1, p.Components, p);
          } else if (key == "TrackRoller3R") {
            _o["TrackRoller3R"] = this.getComponentValue(28, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(28, 2, p.Components, p);
          }
          else if (key == "HoursTrackRoller3L") {
            _o["HoursTrackRoller3L"] = this.getComponentValue(37, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(37, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursTrackRoller3R") {
            _o["HoursTrackRoller3R"] = this.getComponentValue(37, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(37, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateTrackRoller3L") {
            _o["InstallDateTrackRoller3L"] = this.getComponentInsatllDate(28, 1, p.Components, p);
          }
          else if (key == "InstallDateTrackRoller3R") {
            _o["InstallDateTrackRoller3R"] = this.getComponentInsatllDate(28, 2, p.Components, p);
          }

          else if (key == "TrackRoller4L") {
            _o["TrackRoller4L"] = this.getComponentValue(29, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(29, 1, p.Components, p);
          } else if (key == "TrackRoller4R") {
            _o["TrackRoller4R"] = this.getComponentValue(29, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(29, 2, p.Components, p);
          }
          else if (key == "HoursTrackRoller4L") {
            _o["HoursTrackRoller4L"] = this.getComponentValue(38, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(38, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursTrackRoller4R") {
            _o["HoursTrackRoller4R"] = this.getComponentValue(38, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(38, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateTrackRoller4L") {
            _o["InstallDateTrackRoller4L"] = this.getComponentInsatllDate(29, 1, p.Components, p);
          }
          else if (key == "InstallDateTrackRoller4R") {
            _o["InstallDateTrackRoller4R"] = this.getComponentInsatllDate(29, 2, p.Components, p);
          }

          else if (key == "TrackRoller5L") {
            _o["TrackRoller5L"] = this.getComponentValue(30, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(30, 1, p.Components, p);
          } else if (key == "TrackRoller5R") {
            _o["TrackRoller5R"] = this.getComponentValue(30, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(30, 2, p.Components, p);
          }
          else if (key == "HoursTrackRoller5L") {
            _o["HoursTrackRoller5L"] = this.getComponentValue(39, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(39, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursTrackRoller5R") {
            _o["HoursTrackRoller5R"] = this.getComponentValue(39, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(39, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateTrackRoller5L") {
            _o["InstallDateTrackRoller5L"] = this.getComponentInsatllDate(30, 1, p.Components, p);
          }
          else if (key == "InstallDateTrackRoller5R") {
            _o["InstallDateTrackRoller5R"] = this.getComponentInsatllDate(30, 2, p.Components, p);
          }

          else if (key == "TrackRoller6L") {
            _o["TrackRoller6L"] = this.getComponentValue(31, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(31, 1, p.Components, p);
          } else if (key == "TrackRoller6R") {
            _o["TrackRoller6R"] = this.getComponentValue(31, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(31, 2, p.Components, p);
          }
          else if (key == "HoursTrackRoller6L") {
            _o["HoursTrackRoller6L"] = this.getComponentValue(40, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(40, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursTrackRoller6R") {
            _o["HoursTrackRoller6R"] = this.getComponentValue(40, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(40, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateTrackRoller6L") {
            _o["InstallDateTrackRoller6L"] = this.getComponentInsatllDate(31, 1, p.Components, p);
          }
          else if (key == "InstallDateTrackRoller6R") {
            _o["InstallDateTrackRoller6R"] = this.getComponentInsatllDate(31, 2, p.Components, p);
          }

          else if (key == "TrackRoller7L") {
            _o["TrackRoller7L"] = this.getComponentValue(32, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(32, 1, p.Components, p);
          } else if (key == "TrackRoller7R") {
            _o["TrackRoller7R"] = this.getComponentValue(32, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(32, 2, p.Components, p);
          }
          else if (key == "HoursTrackRoller7L") {
            _o["HoursTrackRoller7L"] = this.getComponentValue(41, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(41, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursTrackRoller7R") {
            _o["HoursTrackRoller7R"] = this.getComponentValue(41, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(41, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateTrackRoller7L") {
            _o["InstallDateTrackRoller7L"] = this.getComponentInsatllDate(32, 1, p.Components, p);
          }
          else if (key == "InstallDateTrackRoller7R") {
            _o["InstallDateTrackRoller7R"] = this.getComponentInsatllDate(32, 2, p.Components, p);
          }


          else if (key == "TrackRoller8L") {
            _o["TrackRoller8L"] = this.getComponentValue(33, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(33, 1, p.Components, p);
          } else if (key == "TrackRoller8R") {
            _o["TrackRoller8R"] = this.getComponentValue(33, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(33, 2, p.Components, p);
          }
          else if (key == "HoursTrackRoller8L") {
            _o["HoursTrackRoller8L"] = this.getComponentValue(42, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(42, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursTrackRoller8R") {
            _o["HoursTrackRoller8R"] = this.getComponentValue(42, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(42, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateTrackRoller8L") {
            _o["InstallDateTrackRoller8L"] = this.getComponentInsatllDate(33, 1, p.Components, p);
          }
          else if (key == "InstallDateTrackRoller8R") {
            _o["InstallDateTrackRoller8R"] = this.getComponentInsatllDate(33, 2, p.Components, p);
          }

          else if (key == "TrackRoller9L") {
            _o["TrackRoller9L"] = this.getComponentValue(47, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(47, 1, p.Components, p);
          } else if (key == "TrackRoller9R") {
            _o["TrackRoller9R"] = this.getComponentValue(47, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(47, 2, p.Components, p);
          }
          else if (key == "HoursTrackRoller9L") {
            _o["HoursTrackRoller9L"] = this.getComponentValue(49, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(49, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursTrackRoller9R") {
            _o["HoursTrackRoller9R"] = this.getComponentValue(49, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(49, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateTrackRoller9L") {
            _o["InstallDateTrackRoller9L"] = this.getComponentInsatllDate(47, 1, p.Components, p);
          }
          else if (key == "InstallDateTrackRoller9R") {
            _o["InstallDateTrackRoller9R"] = this.getComponentInsatllDate(47, 2, p.Components, p);
          }

          else if (key == "TrackRoller10L") {
            _o["TrackRoller10L"] = this.getComponentValue(48, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(48, 1, p.Components, p);
          } else if (key == "TrackRoller10R") {
            _o["TrackRoller10R"] = this.getComponentValue(48, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(48, 2, p.Components, p);
          }
          else if (key == "HoursTrackRoller10L") {
            _o["HoursTrackRoller10L"] = this.getComponentValue(50, 1, p.Components, p) == '-1' ? '' : this.getComponentValue(50, 1, p.Components, p) + ' hrs';
          } else if (key == "HoursTrackRoller10R") {
            _o["HoursTrackRoller10R"] = this.getComponentValue(50, 2, p.Components, p) == '-1' ? '' : this.getComponentValue(50, 2, p.Components, p) + ' hrs';
          }
          else if (key == "InstallDateTrackRoller10L") {
            _o["InstallDateTrackRoller10L"] = this.getComponentInsatllDate(48, 1, p.Components, p);
          }
          else if (key == "InstallDateTrackRoller10R") {
            _o["InstallDateTrackRoller10R"] = this.getComponentInsatllDate(48, 2, p.Components, p);
          }
        }
      }

      _data.push(_o)
    })

    const replacer = (key, value) => value === null ? '' : value;
    const header = Object.keys(_data[0]);
    let csv = _data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');
    var a = document.createElement('a');
    var blob = new Blob([csvArray], { type: 'text/csv' }),
      url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = `Component_Overview.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  getComponentInsatllDate(componentHeader: ComponentColumnHeader, side: Side, components: ComponentViewViewModel[], row: ComponentTableInspectionViewModel): string {
    switch (componentHeader) {
      case ComponentColumnHeader.Link:
        {
          let value = this.getComponentInstall(ComponentType.Link, side, components, 0, false, false).toString();
          if (side == 1) row.InstallDateLinkL = value;
          else row.InstallDateLinkR = value;
          return value;
        }
      case ComponentColumnHeader.Bush:
        {
          let value = this.getComponentInstall(ComponentType.Bushing, side, components, 0, false, false).toString();
          if (side == 1) row.InstallDateBushL = value;
          else row.InstallDateBushR = value;
          return value;
        }

      case ComponentColumnHeader.Shoe:

        {
          let value = this.getComponentInstall(ComponentType.Shoe, side, components, 0, false, false).toString();
          if (side == 1) row.InstallDateShoeL = value;
          else row.InstallDateShoeR = value;
          return value;
        }
      case ComponentColumnHeader.FrontIdler:
        {
          let value = this.getComponentInstall(ComponentType.Idler, side, components, 1, false, false).toString();
          if (side == 1) row.InstallDateFIdlerL = value;
          else row.InstallDateFIdlerR = value;
          return value;
        }

      case ComponentColumnHeader.RearIdler:
        {
          let value = this.getComponentInstall(ComponentType.Idler, side, components, 2, false, false).toString();
          if (side == 1) row.InstallDateRIdlerL = value;
          else row.InstallDateRIdlerR = value;
          return value;
        }
      case ComponentColumnHeader.Sprocket:
        {
          let value = this.getComponentInstall(ComponentType.Sprocket, side, components, 0, false, false).toString();
          if (side == 1) row.InstallDateSprocketL = value;
          else row.InstallDateSprocketR = value;
          return value;
        }
      case ComponentColumnHeader.CarrierRoller_1:
        {
          let value = this.getComponentInstall(ComponentType.CarrierRoller, side, components, 1, false, false).toString();
          if (side == 1) row.InstallDateCarrierRoller1L = value;
          else row.InstallDateCarrierRoller1R = value;
          return value;
        }
      case ComponentColumnHeader.CarrierRoller_3:
        {
          let value = this.getComponentInstall(ComponentType.CarrierRoller, side, components, 3, false, false).toString();
          if (side == 1) row.InstallDateCarrierRoller3L = value;
          else row.InstallDateCarrierRoller3R = value;
          return value;
        }
      case ComponentColumnHeader.CarrierRoller_2:
        {
          let value = this.getComponentInstall(ComponentType.CarrierRoller, side, components, 2, false, false).toString();
          if (side == 1) row.InstallDateCarrierRoller2L = value;
          else row.InstallDateCarrierRoller2R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_1:
        {
          let value = this.getComponentInstall(ComponentType.TrackRoller, side, components, 1, false, false).toString();
          if (side == 1) row.InstallDateTrackRoller1L = value;
          else row.InstallDateTrackRoller1R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_2:
        {
          let value = this.getComponentInstall(ComponentType.TrackRoller, side, components, 2, false, false).toString();
          if (side == 1) row.InstallDateTrackRoller2L = value;
          else row.InstallDateTrackRoller2R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_3:
        {
          let value = this.getComponentInstall(ComponentType.TrackRoller, side, components, 3, false, false).toString();
          if (side == 1) row.InstallDateTrackRoller3L = value;
          else row.InstallDateTrackRoller3R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_4:
        {
          let value = this.getComponentInstall(ComponentType.TrackRoller, side, components, 4, false, false).toString();
          if (side == 1) row.InstallDateTrackRoller4L = value;
          else row.InstallDateTrackRoller4R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_5:
        {
          let value = this.getComponentInstall(ComponentType.TrackRoller, side, components, 5, false, false).toString();
          if (side == 1) row.InstallDateTrackRoller5L = value;
          else row.InstallDateTrackRoller5R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_6:
        {
          let value = this.getComponentInstall(ComponentType.TrackRoller, side, components, 6, false, false).toString();
          if (side == 1) row.InstallDateTrackRoller6L = value;
          else row.InstallDateTrackRoller6R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_7:
        {
          let value = this.getComponentInstall(ComponentType.TrackRoller, side, components, 7, false, false).toString();
          if (side == 1) row.InstallDateTrackRoller7L = value;
          else row.InstallDateTrackRoller7R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_8:
        {
          let value = this.getComponentInstall(ComponentType.TrackRoller, side, components, 8, false, false).toString();
          if (side == 1) row.InstallDateTrackRoller8L = value;
          else row.InstallDateTrackRoller8R = value;
          return value;
        }

      case ComponentColumnHeader.TrackRoller_9:
        {
          let value = this.getComponentInstall(ComponentType.TrackRoller, side, components, 9, false, false).toString();
          if (side == 1) row.InstallDateTrackRoller9L = value;
          else row.InstallDateTrackRoller9R = value;
          return value;
        }
      case ComponentColumnHeader.TrackRoller_10:
        {
          let value = this.getComponentInstall(ComponentType.TrackRoller, side, components, 10, false, false).toString();
          if (side == 1) row.InstallDateTrackRoller10L = value;
          else row.InstallDateTrackRoller10R = value;
          return value;
        }

      default:
        return '';
    }
  }

  private getComponentInstall(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, CalcAvg: boolean, track: boolean): number {
    let comps: ComponentViewViewModel[];
    if (position == 0) {
      comps = components.filter(m => m.Compart.CompartType.Id == componentType && m.Side == side);
    } else {
      comps = components.filter(m => m.Compart.CompartType.Id == componentType && m.Side == side && m.Position == position);
    }
    this.x = comps[0] != null ? comps[0].Date : '';
    return this.x;

  }
}
///End of component class

export class EqTableDatabase {
  dataChange: BehaviorSubject<equipmentVwMdl[]> = new BehaviorSubject<equipmentVwMdl[]>([]);
  get data(): equipmentVwMdl[] { return this.dataChange.value; }
  constructor(_equipmentList: equipmentVwMdl[]) {
    this.dataChange.next(_equipmentList);
  }
}

export class EqTableDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }
  customerId = 0;
  jobsiteId = 0;
  equipmentId = 0;
  familyId = 0;
  makeId = 0;
  modelId = 0;
  constructor(private _exampleDatabase: EqTableDatabase, private _paginator: MatPaginator) {
    super();
  }
  public selectionUpdated(customer: number, jobsite: number, equipment: number, family: number, make: number, model: number) {
    this.customerId = customer;
    this.jobsiteId = jobsite;
    this.equipmentId = equipment;
    this.familyId = family;
    this.makeId = make;
    this.modelId = model;
  }
  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<equipmentVwMdl[]> {
    const displayDataChanges = [
      this._exampleDatabase.dataChange,
      this._paginator.page,
      this._filterChange,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._exampleDatabase.data.slice().filter(
        (item: equipmentVwMdl) => {
          const searchSerial = (item.serial).toLowerCase();
          const searchUnit = (item.unit).toLowerCase();
          const searchCustomer = (item.customerName).toLowerCase();
          const searchMake = (item.make).toLowerCase();
          const searchModel = (item.model).toLowerCase();
          const searchFamily = (item.family).toLowerCase();
          if (this.customerId && item.customerId !== this.customerId)
            return false;
          if (this.jobsiteId && item.jobsiteId !== this.jobsiteId)
            return false;
          if (this.equipmentId && item.Id !== this.equipmentId)
            return false;
          if (this.familyId && item.familyId !== this.familyId)
            return false;
          if (this.makeId && item.makeId !== this.makeId)
            return false;
          if (this.modelId && item.modelId !== this.modelId)
            return false;
          return (searchSerial.indexOf(this.filter.toLowerCase()) !== -1
            || searchUnit.indexOf(this.filter.toLowerCase()) !== -1
            || searchCustomer.indexOf(this.filter.toLowerCase()) !== -1
            || searchMake.indexOf(this.filter.toLowerCase()) !== -1
            || searchModel.indexOf(this.filter.toLowerCase()) !== -1
            || searchFamily.indexOf(this.filter.toLowerCase()) !== -1
          );
        }
      );

      // Grab the page's slice of data.
      // const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      // return data.splice(startIndex, this._paginator.pageSize);
      return data;
    });
  }

  disconnect() { }
}

export class ComponentViewTableDatabase {
  dataChange: BehaviorSubject<ComponentTableInspectionViewModel[]> = new BehaviorSubject<ComponentTableInspectionViewModel[]>([]);
  get data(): ComponentTableInspectionViewModel[] { return this.dataChange.value; }
  constructor(_equipmentList: ComponentTableInspectionViewModel[]) {
    this.dataChange.next(_equipmentList);
  }
}

export class ComponentViewTableDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }
  constructor(private _componentDatabase: ComponentViewTableDatabase, private _paginator: MatPaginator) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<ComponentTableInspectionViewModel[]> {
    const displayDataChanges = [
      this._componentDatabase.dataChange,
      this._paginator.page,
      this._filterChange,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._componentDatabase.data.slice().filter(
        (item: ComponentTableInspectionViewModel) => {
          const searchSerial = (item.Equipment.Serial).toLowerCase();
          const searchUnit = (item.Equipment.Unit).toLowerCase();
          return (searchSerial.indexOf(this.filter.toLowerCase()) !== -1
            || searchUnit.indexOf(this.filter.toLowerCase()) !== -1
          );
        }
      );
      return data;
    });
  }




  disconnect() { }
}
